type FirmAccessUser = {
  firm_id?: number;
  is_finance_user?: boolean;
  firm?: { id: number };
  firms?: Array<{ id: number }>;
  roles?: Array<{ slug: string }>;
};

export const getUserFirmIds = (user?: FirmAccessUser | null): number[] => {
  if (!user) return [];
  const ids = new Set<number>();
  if (user.firm_id) ids.add(Number(user.firm_id));
  if (user.firm?.id) ids.add(Number(user.firm.id));
  (user.firms || []).forEach((firm) => {
    if (firm?.id) ids.add(Number(firm.id));
  });
  return Array.from(ids);
};

export const isPmpOrSiteAdminUser = (user?: FirmAccessUser | null): boolean =>
  !!user?.roles?.some((role) => ['pmp_admin', 'site_admin'].includes(role.slug));

export const userCanAccessFirm = (
  user: FirmAccessUser | null | undefined,
  firmId: number | string | undefined | null
): boolean => {
  if (!user || firmId == null || firmId === '') return false;
  if (isPmpOrSiteAdminUser(user)) return true;
  return getUserFirmIds(user).includes(Number(firmId));
};

export const isClientAdminUser = (user?: FirmAccessUser | null): boolean =>
  !!user?.roles?.some((role) => ['client_admin', 'firm_admin', 'firm_main'].includes(role.slug));

export const isClientFinanceUser = (user?: FirmAccessUser | null): boolean => {
  if (!user) return false;
  return user.is_finance_user === true || !!user.roles?.some((role) => role.slug === 'client_finance_user');
};

export const canManageClientInvoices = (user?: FirmAccessUser | null): boolean =>
  isPmpOrSiteAdminUser(user);

export const canViewClientInvoices = (user?: FirmAccessUser | null): boolean =>
  canManageClientInvoices(user) || isClientAdminUser(user) || isClientFinanceUser(user);
